export default "__VITE_ASSET__Tim_yOxu__"